import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card"
}
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "svg-icon svg-icon-5 svg-icon-gray-500 me-1" }
const _hoisted_6 = { class: "card-toolbar" }
const _hoisted_7 = { class: "swap-container m-xl-3" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "svg-icon svg-icon-5 svg-icon-gray-500 me-1" }
const _hoisted_10 = {
  type: "button",
  class: "btn btn-light-primary me-3",
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_customers_export_modal"
}
const _hoisted_11 = { class: "svg-icon svg-icon-2" }
const _hoisted_12 = { class: "svg-icon svg-icon-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-primary rotate",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-start",
  "data-kt-menu-offset": "30px, 30px"
}, " Edit attendance ", -1)
const _hoisted_14 = {
  key: 0,
  class: "d-block menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 fw-semibold w-auto position-absolute",
  "data-kt-menu": "true"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-3 opacity-75" }, null, -1)
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "modal-dialog" }
const _hoisted_18 = { class: "modal-content position-absolute" }
const _hoisted_19 = { class: "modal-header" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Are You Sure?", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "ki-duotone ki-cross fs-2x" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "path1" }),
  /*#__PURE__*/_createElementVNode("span", { class: "path2" })
], -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { class: "modal-body" }
const _hoisted_24 = { class: "text-danger" }
const _hoisted_25 = { class: "d-flex align-items-center justify-content-start details" }
const _hoisted_26 = { class: "fw-bold" }
const _hoisted_27 = { class: "text-primary" }
const _hoisted_28 = { class: "border-left fw-bold" }
const _hoisted_29 = { class: "text-primary" }
const _hoisted_30 = { class: "border-left fw-bold" }
const _hoisted_31 = { class: "text-primary" }
const _hoisted_32 = { class: "border-left fw-bold" }
const _hoisted_33 = { class: "text-primary" }
const _hoisted_34 = { class: "modal-footer" }
const _hoisted_35 = ["disabled"]
const _hoisted_36 = { class: "modal-dialog" }
const _hoisted_37 = { class: "modal-content position-absolute" }
const _hoisted_38 = { class: "modal-header" }
const _hoisted_39 = {
  key: 0,
  class: "modal-title"
}
const _hoisted_40 = {
  key: 1,
  class: "modal-title"
}
const _hoisted_41 = {
  key: 2,
  class: "modal-title"
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("i", { class: "ki-duotone ki-cross fs-2x" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "path1" }),
  /*#__PURE__*/_createElementVNode("span", { class: "path2" })
], -1)
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = { class: "modal-body" }
const _hoisted_45 = {
  key: 0,
  class: "fv-row d-flex justify-content-center align-items-center"
}
const _hoisted_46 = {
  key: 1,
  class: "fv-row d-flex justify-content-center align-items-center"
}
const _hoisted_47 = {
  key: 2,
  class: "fv-row"
}
const _hoisted_48 = {
  disabled: "",
  selected: "",
  value: "0"
}
const _hoisted_49 = ["value"]
const _hoisted_50 = { class: "modal-footer" }
const _hoisted_51 = ["disabled"]
const _hoisted_52 = {
  class: "d-flex justify-content-end",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_53 = { class: "svg-icon svg-icon-2" }
const _hoisted_54 = { class: "card-body pt-0 lesson-table" }
const _hoisted_55 = {
  key: 0,
  class: "d-flex flex-wrap align-items-center gap-3 mb-4 p-4 bg-light-primary rounded"
}
const _hoisted_56 = { class: "fw-bold text-gray-700" }
const _hoisted_57 = { class: "d-flex align-items-center gap-2" }
const _hoisted_58 = { class: "form-label mb-0 text-muted small" }
const _hoisted_59 = { class: "d-flex align-items-center gap-2" }
const _hoisted_60 = { class: "form-label mb-0 text-muted small" }
const _hoisted_61 = { class: "d-flex align-items-center gap-2" }
const _hoisted_62 = { class: "form-label mb-0 text-muted small" }
const _hoisted_63 = ["checked", "indeterminate"]
const _hoisted_64 = { class: "form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_65 = ["value", "onChange", "disabled"]
const _hoisted_66 = ["title"]
const _hoisted_67 = { class: "truncate" }
const _hoisted_68 = ["title"]
const _hoisted_69 = ["title"]
const _hoisted_70 = {
  key: 1,
  class: "fv-row"
}
const _hoisted_71 = ["title"]
const _hoisted_72 = {
  key: 1,
  class: "fv-row"
}
const _hoisted_73 = {
  key: 0,
  class: "w-200"
}
const _hoisted_74 = {
  key: 1,
  class: "fv-row"
}
const _hoisted_75 = ["value", "onChange"]
const _hoisted_76 = ["title"]
const _hoisted_77 = {
  key: 1,
  class: "fv-row"
}
const _hoisted_78 = {
  key: 0,
  class: "w-200 truncate"
}
const _hoisted_79 = {
  key: 1,
  class: "fv-row"
}
const _hoisted_80 = {
  disabled: "",
  selected: "",
  value: "0"
}
const _hoisted_81 = ["value"]
const _hoisted_82 = { key: 0 }
const _hoisted_83 = {
  key: 1,
  class: "fv-row"
}
const _hoisted_84 = {
  disabled: "",
  selected: "",
  value: "0"
}
const _hoisted_85 = ["hidden", "value"]
const _hoisted_86 = { class: "truncate" }
const _hoisted_87 = ["onClick"]
const _hoisted_88 = ["title"]
const _hoisted_89 = {
  class: "modal fade",
  tabindex: "-1",
  id: "kt_modal_1"
}
const _hoisted_90 = { class: "modal-dialog" }
const _hoisted_91 = { class: "modal-content" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "modal-title" }, "Edit Comment"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "ki-duotone ki-cross fs-1" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "path1" }),
      /*#__PURE__*/_createElementVNode("span", { class: "path2" })
    ])
  ])
], -1)
const _hoisted_93 = { class: "modal-body" }
const _hoisted_94 = { class: "col-lg-12 fv-row" }
const _hoisted_95 = { class: "modal-footer" }
const _hoisted_96 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-light",
  "data-bs-dismiss": "modal"
}, " Close ", -1)
const _hoisted_97 = { class: "truncate" }
const _hoisted_98 = ["title"]
const _hoisted_99 = ["title"]
const _hoisted_100 = ["onUpdate:modelValue", "onChange"]
const _hoisted_101 = {
  disabled: "",
  selected: "",
  value: null
}
const _hoisted_102 = ["value"]
const _hoisted_103 = ["title"]
const _hoisted_104 = ["onUpdate:modelValue", "onChange"]
const _hoisted_105 = {
  disabled: "",
  selected: "",
  value: null
}
const _hoisted_106 = ["value"]
const _hoisted_107 = {
  key: 0,
  class: "fv-row"
}
const _hoisted_108 = { key: 1 }
const _hoisted_109 = {
  key: 0,
  class: "w-200"
}
const _hoisted_110 = {
  key: 1,
  class: "fv-row w-200"
}
const _hoisted_111 = ["onUpdate:modelValue", "onChange"]
const _hoisted_112 = ["onClick"]
const _hoisted_113 = { class: "svg-icon svg-icon-3" }
const _hoisted_114 = {
  key: 1,
  style: {"opacity":"0.7"}
}
const _hoisted_115 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_LessonsFilter = _resolveComponent("LessonsFilter")!
  const _component_SwapLessons = _resolveComponent("SwapLessons")!
  const _component_vue3_json_excel = _resolveComponent("vue3-json-excel")!
  const _component_ReportAttendence = _resolveComponent("ReportAttendence")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_Field = _resolveComponent("Field")!
  const _component_SearchField = _resolveComponent("SearchField")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_ctx.can('read', 'lesson'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              disabled: _ctx.disabledFilterButton,
              type: "button",
              class: "btn btn-flex btn-light btn-active-primary fw-bolder",
              "data-kt-menu-trigger": "click",
              "data-kt-menu-placement": "bottom-start",
              "data-kt-menu-flip": "top-end"
            }, [
              _createElementVNode("span", _hoisted_5, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen031.svg" })
              ]),
              _createTextVNode(" " + _toDisplayString(_ctx.translate('filter')), 1)
            ], 8, _hoisted_4),
            _createVNode(_component_LessonsFilter, {
              onTypeSelected: _ctx.searchLessons,
              onReset: _ctx.onReset
            }, null, 8, ["onTypeSelected", "onReset"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                disabled: _ctx.selectedRecored.length !== 2,
                type: "button",
                class: "btn btn-flex btn-light btn-active-primary fw-bolder",
                "data-kt-menu-trigger": "click",
                "data-kt-menu-placement": "bottom-start",
                "data-kt-menu-flip": "top-end"
              }, [
                _createElementVNode("span", _hoisted_9, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr032.svg" })
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.translate('Swap')), 1)
              ], 8, _hoisted_8),
              _createVNode(_component_SwapLessons, { onTypeSelected: _ctx.swapLesson }, null, 8, ["onTypeSelected"])
            ]),
            (!_ctx.isTrainer)
              ? (_openBlock(), _createBlock(_component_vue3_json_excel, {
                  key: 0,
                  "json-data": _ctx.excelData,
                  fields: _ctx.excelHeader,
                  worksheet: "lessons WorkSheet",
                  name: "lessons.xls"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("button", _hoisted_10, [
                      _createElementVNode("span", _hoisted_11, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr078.svg" })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.translate('Export Lessons')), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["json-data", "fields"]))
              : _createCommentVNode("", true),
            (!_ctx.isTrainer)
              ? (_openBlock(), _createBlock(_component_ReportAttendence, { key: 1 }))
              : _createCommentVNode("", true),
            (_ctx.selectedRecored.length > 0)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  type: "button",
                  class: "btn btn-light-primary me-3",
                  "data-bs-toggle": "modal",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updateLessonsInformation && _ctx.updateLessonsInformation(...args)))
                }, [
                  _createElementVNode("span", _hoisted_12, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr078.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.translate('Update')), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.selectedRecored.length > 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 3,
                  claas: "position-relative",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showMenu = !_ctx.showMenu))
                }, [
                  _hoisted_13,
                  (_ctx.showMenu)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _hoisted_15,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attendncies, (attendence) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "menu-item px-3",
                            key: attendence.id
                          }, [
                            _createElementVNode("span", {
                              href: "#",
                              class: "menu-link px-3",
                              "data-bs-toggle": "modal",
                              "data-bs-target": "#kt_modal_3",
                              onClick: ($event: any) => (_ctx.checkLessonsAttendence(attendence))
                            }, _toDisplayString(attendence.nameEn), 9, _hoisted_16)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(["modal fade", _ctx.showModal ? 'show' : '']),
              id: "kt_modal_3'",
              style: _normalizeStyle(_ctx.showModal ? 'display:block' : 'display:none')
            }, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _createElementVNode("div", {
                      class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
                      "data-bs-dismiss": "modal",
                      "aria-label": "Close",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.resetAttendence && _ctx.resetAttendence(...args)))
                    }, _hoisted_22)
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.checkAttendenceResult, (reason) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: reason.reason
                      }, [
                        _createElementVNode("strong", _hoisted_24, _toDisplayString(reason.reason), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reason.lesson, (lesson) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "",
                            key: lesson.id
                          }, [
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("p", _hoisted_26, [
                                _createTextVNode(" Horse : "),
                                _createElementVNode("span", _hoisted_27, _toDisplayString(lesson.horseName), 1)
                              ]),
                              _createElementVNode("p", _hoisted_28, [
                                _createTextVNode(" Arena : "),
                                _createElementVNode("span", _hoisted_29, _toDisplayString(lesson.arenaName), 1)
                              ]),
                              _createElementVNode("p", _hoisted_30, [
                                _createTextVNode(" Customer : "),
                                _createElementVNode("span", _hoisted_31, _toDisplayString(lesson.customerName), 1)
                              ]),
                              _createElementVNode("p", _hoisted_32, [
                                _createTextVNode(" Trainer : "),
                                _createElementVNode("span", _hoisted_33, _toDisplayString(lesson.trainerName), 1)
                              ])
                            ])
                          ]))
                        }), 128))
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-light",
                      "data-bs-dismiss": "modal",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.resetAttendence && _ctx.resetAttendence(...args)))
                    }, " Close "),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-danger",
                      disabled: !_ctx.disableCompleteButton(),
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.completeUpdateAttendence && _ctx.completeUpdateAttendence(...args)))
                    }, " Complete ", 8, _hoisted_35)
                  ])
                ])
              ])
            ], 6),
            _createElementVNode("div", {
              class: _normalizeClass(["modal fade", _ctx.showReasonModal ? 'show' : '']),
              id: "kt_modal_3'",
              style: _normalizeStyle(_ctx.showReasonModal ? 'display:block' : 'display:none')
            }, [
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    (_ctx.showCancellationReason)
                      ? (_openBlock(), _createElementBlock("h5", _hoisted_39, " 'Cancellation Reason' "))
                      : (_ctx.showFreezeDate)
                        ? (_openBlock(), _createElementBlock("h5", _hoisted_40, " Freeze Reason "))
                        : (_ctx.showCancellByKRC)
                          ? (_openBlock(), _createElementBlock("h5", _hoisted_41, " Cancel By KRC "))
                          : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
                      "data-bs-dismiss": "modal",
                      "aria-label": "Close",
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.resetAttendence && _ctx.resetAttendence(...args)))
                    }, _hoisted_43)
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    (_ctx.showFreezeDate)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                          _createVNode(_component_Field, {
                            modelValue: _ctx.freezeDate,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.freezeDate) = $event)),
                            type: "date",
                            name: "startDate",
                            autocomplete: "off",
                            class: "form-control form-control-lg form-control-solid",
                            placeholder: _ctx.translate('Start Date')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_DatePicker, {
                                id: "freezeDate",
                                class: "form-control form-control-lg form-control-solid",
                                modelValue: _ctx.freezeDate,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.freezeDate) = $event)),
                                placeholder: _ctx.translate('dd/mm/yyyy'),
                                fieldId: "freezeDate",
                                "today-only": true
                              }, null, 8, ["modelValue", "placeholder"])
                            ]),
                            _: 1
                          }, 8, ["modelValue", "placeholder"])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.showCancellByKRC)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                          _createVNode(_component_Field, {
                            modelValue: _ctx.KRCCancelDate,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.KRCCancelDate) = $event)),
                            type: "date",
                            name: "startDate",
                            autocomplete: "off",
                            class: "form-control form-control-lg form-control-solid",
                            placeholder: _ctx.translate('Start Date')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_DatePicker, {
                                id: "KRCCancelDate",
                                class: "form-control form-control-lg form-control-solid",
                                modelValue: _ctx.KRCCancelDate,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.KRCCancelDate) = $event)),
                                placeholder: _ctx.translate('dd/mm/yyyy'),
                                fieldId: "KRCCancelDate",
                                "today-only": true
                              }, null, 8, ["modelValue", "placeholder"])
                            ]),
                            _: 1
                          }, 8, ["modelValue", "placeholder"])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.showCancellationReason)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                          _createVNode(_component_Field, {
                            as: "select",
                            name: "trainerId",
                            autocomplete: "off",
                            class: "form-control form-control-lg form-control-solid",
                            modelValue: _ctx.cancellationReasonId,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.cancellationReasonId) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("option", _hoisted_48, _toDisplayString(_ctx.translate('select cancel reason')), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cancelReason, (reason) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: reason.id,
                                  value: reason.id
                                }, _toDisplayString(reason.nameEn), 9, _hoisted_49))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-light",
                      "data-bs-dismiss": "modal",
                      onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.resetAttendence && _ctx.resetAttendence(...args)))
                    }, " Close "),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-danger",
                      disabled: 
                    !_ctx.freezeDate &&
                    _ctx.cancellationReasonId === 0 &&
                    !_ctx.showCancellByKRC
                  ,
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.checkLessonsAttendence(_ctx.attendanceParam, true)))
                    }, " Complete ", 8, _hoisted_51)
                  ])
                ])
              ])
            ], 6),
            _createElementVNode("div", _hoisted_52, [
              (_ctx.can('create', 'lesson'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-primary mx-2",
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.goTo('lessons-creating')))
                  }, [
                    _createElementVNode("span", _hoisted_53, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotone/Navigation/Plus.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.translate('add New lessons')), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_54, [
          (_ctx.allSelectableSelected && _ctx.selectedRecored.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.translate('Bulk edit')) + " (" + _toDisplayString(_ctx.selectedRecored.length) + " " + _toDisplayString(_ctx.translate('selected')) + ") ", 1),
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("label", _hoisted_58, _toDisplayString(_ctx.translate('Arena')), 1),
                  _createVNode(_component_SearchField, {
                    "model-value": _ctx.bulkArenaId,
                    options: _ctx.arenas,
                    mode: "single",
                    label: _ctx.translate('Select arena'),
                    className: "form-select-sm w-200",
                    "onUpdate:modelValue": _ctx.applyBulkArena
                  }, null, 8, ["model-value", "options", "label", "onUpdate:modelValue"])
                ]),
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("label", _hoisted_60, _toDisplayString(_ctx.translate('Time')), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "time",
                    class: "form-control form-control-sm form-control-solid w-150",
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.bulkTime) = $event)),
                    onChange: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.applyBulkTime && _ctx.applyBulkTime(...args)))
                  }, null, 544), [
                    [_vModelText, _ctx.bulkTime]
                  ])
                ]),
                _createElementVNode("div", _hoisted_61, [
                  _createElementVNode("label", _hoisted_62, _toDisplayString(_ctx.translate('trainer Name')), 1),
                  _createVNode(_component_SearchField, {
                    "model-value": _ctx.bulkTrainerId,
                    options: _ctx.trainers,
                    mode: "single",
                    label: _ctx.translate('Select trainers'),
                    className: "form-select-sm w-200",
                    "onUpdate:modelValue": _ctx.applyBulkTrainer
                  }, null, 8, ["model-value", "options", "label", "onUpdate:modelValue"])
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_Datatable, {
            "table-data": _ctx.tableData,
            "table-header": _ctx.tableHeader,
            loading: _ctx.loading,
            total: _ctx.totalItems,
            "rows-per-page": 100,
            "enable-items-per-page-dropdown": false,
            "sticky-header": true,
            onCurrentChange: _ctx.pageChanged
          }, {
            "header-checkbox": _withCtx(() => [
              _createElementVNode("div", {
                class: "form-check form-check-sm form-check-custom form-check-solid",
                onClick: _cache[17] || (_cache[17] = _withModifiers(() => {}, ["stop"]))
              }, [
                _createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  checked: _ctx.allSelectableSelected,
                  indeterminate: _ctx.indeterminate,
                  onChange: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.toggleSelectAll && _ctx.toggleSelectAll(...args)))
                }, null, 40, _hoisted_63)
              ])
            ]),
            "cell-checkbox": _withCtx(({ row: lessons }) => [
              _createElementVNode("div", _hoisted_64, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  value: lessons.id,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.selectedRecored) = $event)),
                  onChange: ($event: any) => (_ctx.onRowCheckboxChange(lessons)),
                  disabled: _ctx.isSelectRecordEnabled(lessons.attendanceName)
                }, null, 40, _hoisted_65), [
                  [_vModelCheckbox, _ctx.selectedRecored]
                ])
              ])
            ]),
            "cell-trainerName": _withCtx(({ row: lesson }) => [
              (!_ctx.enableEditing(lesson.id, lesson.attendanceName))
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "w-200 truncate",
                    title: lesson.trainerName
                  }, _toDisplayString(lesson.trainerName), 9, _hoisted_66))
                : _createCommentVNode("", true),
              (_ctx.enableEditing(lesson.id, lesson.attendanceName))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(["fv-row", _ctx.disabledField[lesson.id] ? 'disabled' : ''])
                  }, [
                    _createVNode(_component_SearchField, {
                      modelValue: lesson.trainerId,
                      "onUpdate:modelValue": ($event: any) => ((lesson.trainerId) = $event),
                      options: _ctx.trainers,
                      mode: "single",
                      label: _ctx.translate('Select trainers'),
                      className: "form-select-sm w-200",
                      onChange: 
                (newTrainerId) =>
                  _ctx.handleSelectedField(lesson.id, newTrainerId, 'trainerId')
              
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "label", "onChange"])
                  ], 2))
                : _createCommentVNode("", true)
            ]),
            "cell-balance": _withCtx(({ row: lesson }) => [
              _createElementVNode("span", _hoisted_67, _toDisplayString(lesson.balance ? lesson.balance : 0), 1)
            ]),
            "cell-customerName": _withCtx(({ row: lesson }) => [
              _createElementVNode("span", {
                class: "truncate",
                title: lesson.customerName
              }, _toDisplayString(lesson.customerName), 9, _hoisted_68)
            ]),
            "cell-horseName": _withCtx(({ row: lesson }) => [
              (!_ctx.enableEditing(lesson.id, lesson.attendanceName))
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    title: lesson.horseName,
                    class: "truncate w-200"
                  }, _toDisplayString(lesson.horseName), 9, _hoisted_69))
                : _createCommentVNode("", true),
              (_ctx.enableEditing(lesson.id, lesson.attendanceName))
                ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                    _createVNode(_component_SearchField, {
                      modelValue: lesson.horseId,
                      "onUpdate:modelValue": ($event: any) => ((lesson.horseId) = $event),
                      options: (_ctx.horsesList[lesson.id] || []).filter(Boolean),
                      mode: "single",
                      label: _ctx.translate('Select horse'),
                      className: "form-select-sm w-200",
                      "track-by": "nameEn",
                      onChange: 
                (newHorseId) =>
                  _ctx.handleSelectedField(
                    lesson.id,
                    newHorseId,
                    'horseId',
                    lesson.time
                  )
              
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "label", "onChange"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            "cell-arenaName": _withCtx(({ row: lesson }) => [
              (!_ctx.enableEditing(lesson.id, lesson.attendanceName))
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    title: lesson.arenaName,
                    class: "w-200 truncate"
                  }, _toDisplayString(lesson.arenaName), 9, _hoisted_71))
                : _createCommentVNode("", true),
              (_ctx.enableEditing(lesson.id, lesson.attendanceName))
                ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                    _createVNode(_component_SearchField, {
                      modelValue: lesson.arenaId,
                      "onUpdate:modelValue": ($event: any) => ((lesson.arenaId) = $event),
                      options: _ctx.arenas,
                      mode: "single",
                      label: _ctx.translate('Select arena'),
                      className: "form-select-sm w-200",
                      onChange: 
                (newArenaId) =>
                  _ctx.handleSelectedField(lesson.id, newArenaId, 'arenaId')
              
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "label", "onChange"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            "cell-time": _withCtx(({ row: lesson }) => [
              (!_ctx.enableEditing(lesson.id, lesson.attendanceName))
                ? (_openBlock(), _createElementBlock("span", _hoisted_73, _toDisplayString(_ctx.format12(_ctx.getEffectiveTime(lesson))), 1))
                : _createCommentVNode("", true),
              (_ctx.enableEditing(lesson.id, lesson.attendanceName))
                ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                    _createElementVNode("input", {
                      type: "time",
                      class: "form-control form-control-sm form-control-solid",
                      value: _ctx.getEffectiveTime(lesson),
                      onChange: ($event: any) => (_ctx.handleTimeChange(lesson, $event))
                    }, null, 40, _hoisted_75)
                  ]))
                : _createCommentVNode("", true)
            ]),
            "cell-groomerName": _withCtx(({ row: lesson }) => [
              (!_ctx.enableEditing(lesson.id, lesson.attendanceName))
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    title: lesson.groomerName,
                    class: "w-200 truncate"
                  }, _toDisplayString(lesson.groomerName || 'None'), 9, _hoisted_76))
                : _createCommentVNode("", true),
              (_ctx.enableEditing(lesson.id, lesson.attendanceName))
                ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                    _createVNode(_component_SearchField, {
                      modelValue: lesson.groomerId,
                      "onUpdate:modelValue": ($event: any) => ((lesson.groomerId) = $event),
                      options: _ctx.groomers,
                      mode: "single",
                      label: _ctx.translate('groomer'),
                      "have-none": true,
                      className: "form-select-sm w-200",
                      onChange: 
                (newGroomerId) =>
                  _ctx.handleSelectedField(lesson.id, newGroomerId, 'groomerId')
              
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "label", "onChange"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            "cell-dayName": _withCtx(({ row: lesson }) => [
              (!_ctx.enableEditing(lesson.id, lesson.attendanceName))
                ? (_openBlock(), _createElementBlock("span", _hoisted_78, _toDisplayString(lesson.dayName), 1))
                : _createCommentVNode("", true),
              (_ctx.enableEditing(lesson.id, lesson.attendanceName))
                ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                    _createVNode(_component_Field, {
                      as: "select",
                      name: "trainerId",
                      autocomplete: "off",
                      class: "form-control form-control-sm form-control-solid",
                      modelValue: lesson.dayId,
                      "onUpdate:modelValue": ($event: any) => ((lesson.dayId) = $event),
                      onChange: ($event: any) => (_ctx.handleSelectedField(lesson.id, lesson.dayId, 'dayId'))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("option", _hoisted_80, _toDisplayString(_ctx.translate('select day')), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dayList, (day) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: day.id,
                            value: day.id
                          }, _toDisplayString(day.nameEn), 9, _hoisted_81))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            "cell-durationName": _withCtx(({ row: lesson }) => [
              (!_ctx.enableEditing(lesson.id, lesson.attendanceName))
                ? (_openBlock(), _createElementBlock("span", _hoisted_82, _toDisplayString(lesson.durationName), 1))
                : _createCommentVNode("", true),
              (_ctx.enableEditing(lesson.id, lesson.attendanceName))
                ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                    _createVNode(_component_Field, {
                      as: "select",
                      name: "trainerId",
                      autocomplete: "off",
                      class: "form-control form-control-sm form-control-solid",
                      modelValue: lesson.durationId,
                      "onUpdate:modelValue": ($event: any) => ((lesson.durationId) = $event),
                      onChange: ($event: any) => (
                _ctx.handleSelectedField(lesson.id, lesson.durationId, 'durationId')
              )
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("option", _hoisted_84, _toDisplayString(_ctx.translate('select duration')), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.durationList, (duration) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: duration.id,
                            hidden: duration.slug == 60 || duration.slug == 15,
                            value: duration.id
                          }, _toDisplayString(duration.nameEn), 9, _hoisted_85))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            "cell-horseLocation": _withCtx(({ row: lesson }) => [
              _createElementVNode("span", _hoisted_86, _toDisplayString(lesson.horseLocation), 1)
            ]),
            "cell-comment": _withCtx(({ row: lesson }) => [
              _createElementVNode("span", {
                type: "button",
                class: "comment-truncate",
                "data-bs-toggle": "modal",
                "data-bs-target": "#kt_modal_1",
                onClick: ($event: any) => {
              _ctx.lessonComment = lesson.comment;
              _ctx.lessonId = lesson.id;
            }
              }, [
                _createElementVNode("span", {
                  "data-bs-toggle": "tooltip",
                  "data-bs-placement": "top",
                  title: lesson.comment
                }, _toDisplayString(lesson.comment ? lesson.comment : '-'), 9, _hoisted_88)
              ], 8, _hoisted_87),
              _createElementVNode("div", _hoisted_89, [
                _createElementVNode("div", _hoisted_90, [
                  _createElementVNode("div", _hoisted_91, [
                    _hoisted_92,
                    _createElementVNode("div", _hoisted_93, [
                      _createElementVNode("div", _hoisted_94, [
                        _createVNode(_component_Field, {
                          as: "textarea",
                          name: "comment",
                          autocomplete: "off",
                          class: "form-control form-control-lg form-control-solid",
                          modelValue: _ctx.lessonComment,
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.lessonComment) = $event)),
                          rows: "5",
                          onChange: _cache[20] || (_cache[20] = ($event: any) => (
                        _ctx.handleSelectedField(_ctx.lessonId, _ctx.lessonComment, 'comment')
                      ))
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_95, [
                      _hoisted_96,
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-primary",
                        "data-bs-dismiss": "modal",
                        onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.updateLessonsInformation && _ctx.updateLessonsInformation(...args)))
                      }, " Save changes ")
                    ])
                  ])
                ])
              ])
            ]),
            "cell-attendanceName": _withCtx(({ row: lesson }) => [
              _createElementVNode("span", _hoisted_97, _toDisplayString(lesson.attendanceName), 1)
            ]),
            "cell-classCategory": _withCtx(({ row: lesson }) => [
              (!_ctx.enableEditing(lesson.id, lesson.attendanceName))
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "w-200 truncate",
                    title: lesson.classCategory
                  }, _toDisplayString(lesson.classCategory), 9, _hoisted_98))
                : _createCommentVNode("", true),
              (_ctx.enableEditing(lesson.id, lesson.attendanceName))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(["fv-row", _ctx.disabledField[lesson.id] ? 'disabled' : ''])
                  }, [
                    _createVNode(_component_SearchField, {
                      modelValue: lesson.classCategoryId,
                      "onUpdate:modelValue": ($event: any) => ((lesson.classCategoryId) = $event),
                      options: _ctx.categoryList,
                      mode: "single",
                      label: _ctx.translate('Select Category'),
                      className: "form-select-sm w-200",
                      "track-by": "nameEn",
                      onChange: 
                (newClassLevel) => {
                  _ctx.handleSelectedField(
                    lesson.id,
                    newClassLevel,
                    'classCategoryId'
                  );
                  lesson.classLevelId = null;
                  _ctx.handleCategoryChanged(lesson, newClassLevel);
                }
              
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "label", "onChange"])
                  ], 2))
                : _createCommentVNode("", true)
            ]),
            "cell-classLevelName": _withCtx(({ row: lesson }) => [
              (!_ctx.enableEditing(lesson.id, lesson.attendanceName))
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "w-200 truncate",
                    title: lesson.classLevelName
                  }, _toDisplayString(lesson.classLevelName), 9, _hoisted_99))
                : _createCommentVNode("", true),
              (_ctx.enableEditing(lesson.id, lesson.attendanceName))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(["fv-row", _ctx.disabledField[lesson.id] ? 'disabled' : ''])
                  }, [
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": ($event: any) => ((lesson.classLevelId) = $event),
                      class: "form-select w-200 form-select-sm form-select-solid",
                      onChange: ($event: any) => (
                _ctx.handleSelectedField(
                  lesson.id,
                  $event.target.value,
                  'classLevelId'
                )
              )
                    }, [
                      _createElementVNode("option", _hoisted_101, _toDisplayString(_ctx.translate('Select Level')), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.matchedClassLevelList[lesson.id] || [], (level) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: level.id,
                          value: level.id
                        }, _toDisplayString(level.name), 9, _hoisted_102))
                      }), 128))
                    ], 40, _hoisted_100), [
                      [_vModelSelect, lesson.classLevelId]
                    ])
                  ], 2))
                : _createCommentVNode("", true)
            ]),
            "cell-classType": _withCtx(({ row: lesson }) => [
              (!_ctx.enableEditing(lesson.id, lesson.attendanceName))
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "w-200 truncate",
                    title: lesson.classType
                  }, _toDisplayString(lesson.classType), 9, _hoisted_103))
                : _createCommentVNode("", true),
              (_ctx.enableEditing(lesson.id, lesson.attendanceName))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(["fv-row", _ctx.disabledField[lesson.id] ? 'disabled' : ''])
                  }, [
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": ($event: any) => ((lesson.typeId) = $event),
                      class: "form-select w-200 form-select-sm form-select-solid",
                      onChange: ($event: any) => (
                _ctx.handleSelectedField(lesson.id, $event.target.value, 'typeId')
              )
                    }, [
                      _createElementVNode("option", _hoisted_105, _toDisplayString(_ctx.translate('Select Level')), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classTypeList, (level) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: level.id,
                          value: level.id
                        }, _toDisplayString(level.nameEn), 9, _hoisted_106))
                      }), 128))
                    ], 40, _hoisted_104), [
                      [_vModelSelect, lesson.typeId]
                    ])
                  ], 2))
                : _createCommentVNode("", true)
            ]),
            "cell-startDate": _withCtx(({ row: lesson }) => [
              (!_ctx.enableEditing(lesson.id, lesson.attendanceName))
                ? (_openBlock(), _createElementBlock("span", _hoisted_107, _toDisplayString(_ctx.convertDateDDMMYYYY(lesson.startDate)), 1))
                : _createCommentVNode("", true),
              (_ctx.enableEditing(lesson.id, lesson.attendanceName))
                ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                    _createVNode(_component_Field, {
                      modelValue: lesson.startDate,
                      "onUpdate:modelValue": ($event: any) => ((lesson.startDate) = $event),
                      name: "startDate",
                      autocomplete: "off",
                      class: "form-control form-control-sm form-control-solid",
                      placeholder: _ctx.translate('Start Date')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DatePicker, {
                          id: "startDate",
                          class: "form-control form-control-lg form-control-solid",
                          modelValue: lesson.startDate,
                          "onUpdate:modelValue": ($event: any) => ((lesson.startDate) = $event),
                          placeholder: _ctx.translate('dd/mm/yyyy'),
                          fieldId: "startDate",
                          "today-only": true,
                          onChange: 
                  (date) => {
                    _ctx.handleSelectedField(lesson.id, date, 'startDate');
                  }
                
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "onChange"])
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            "cell-price": _withCtx(({ row: lesson }) => [
              (!_ctx.enableEditing(lesson.id, lesson.attendanceName))
                ? (_openBlock(), _createElementBlock("span", _hoisted_109, _toDisplayString(lesson.price), 1))
                : _createCommentVNode("", true),
              (_ctx.enableEditing(lesson.id, lesson.attendanceName))
                ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      name: "price",
                      min: "0",
                      autocomplete: "off",
                      class: "form-control form-control-sm form-control-solid",
                      "onUpdate:modelValue": ($event: any) => ((lesson.price) = $event),
                      onChange: ($event: any) => (
                _ctx.handleSelectedField(lesson.id, String(lesson.price), 'price')
              )
                    }, null, 40, _hoisted_111), [
                      [_vModelText, lesson.price]
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            "cell-actions": _withCtx(({ row: lesson }) => [
              (
              _ctx.can('remove', 'lesson') && lesson.attendanceName === 'pending'
            )
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    onClick: ($event: any) => (_ctx.toggleStatusUser(lesson)),
                    href: "#",
                    class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
                  }, [
                    _createElementVNode("span", _hoisted_113, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen027.svg" })
                    ])
                  ], 8, _hoisted_112))
                : (_ctx.can('remove', 'lesson'))
                  ? (_openBlock(), _createElementBlock("a", _hoisted_114, [
                      _createElementVNode("span", _hoisted_115, [
                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen027.svg" })
                      ])
                    ]))
                  : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["table-data", "table-header", "loading", "total", "onCurrentChange"])
        ])
      ]))
    : _createCommentVNode("", true)
}